import styled from 'styled-components';
import { TYPOGRAPHY, COLOR } from '../../../../../theme/constants';
import config from './../../../../../config';

export const TimeframeBorder = styled.div<{ pos?: string }>`
   border-left: solid 1px ${COLOR.BLACK};
   display: inline;
   position: absolute;
   top: 19px;
   right: 0;
   height: 25%;

   ${props => {
      if (props.pos === 'left') {
         return `
        right: auto;
        left: 0;
      `;
      }
   }}
`;

export const TimeframeDisplayRow = styled.tr`
   // setting width on cell directly does not work on table-layout: auto
   th:last-child {
      width: 7%;
      min-width: 60px;
      padding: 9px 0;

      @media only screen and (max-width: 1340px) {
         width: 5%;
      }
   }
`;

export const TimeframeDisplayDate = styled.th`
   position: relative;
   color: ${COLOR.BLACK};
   text-align: center;
   padding: 18px 0px;
   font-size: 12px;
   ${TYPOGRAPHY.BOLD};
`;

export const TimeframeDisplayDateData = styled.span`
   padding: 0 20px;
`;

export const TimeframeDisplayCharting = styled(TimeframeDisplayDate)``;

export const TimeframeDisplayHeader = styled(TimeframeDisplayDate)`
   text-align: left;
   padding: 0px 45px 0px 30px;
`;
